import { ApolloError } from '@apollo/client';

const errorCodes = {
  BAD_USER_INPUT: 'BAD_USER_INPUT',
};

export type GraphqlError = {
  fieldsError?: GraphqlInputError[];
};

export type GraphqlInputError = {
  field: string;
  message: string[];
};

export type GraphqlGenericError = {
  message: string;
};

type GraphqlReturnResponse = {
  fieldsError: GraphqlInputError[];
  formError: GraphqlGenericError[];
};

export const handleGraphqlError = (error: ApolloError): GraphqlReturnResponse | undefined => {
  if (error.networkError) {
    console.error('Network error', error);
    return;
  }
  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    const fieldsError: GraphqlInputError[] = [];
    const formError: GraphqlGenericError[] = [];
    error.graphQLErrors.forEach((graphqlError) => {
      if (graphqlError.extensions) {
        const extensions = graphqlError.extensions;
        if (extensions.code === errorCodes.BAD_USER_INPUT) {
          for (const attr in extensions) {
            fieldsError.push({ field: extensions[attr].path, message: [extensions[attr].message] });
          }
        } else {
          formError.push({ message: graphqlError.message });
        }
      }
    });

    return { fieldsError, formError };
  }
};
